export default __webpack_public_path__ + "static/media/selectedScheduleLogo.a9fc7236.svg";